if (!customElements.get('media-gallery')) {
	customElements.define(
		'media-gallery',
		class MediaGallery extends HTMLElement {
			constructor() {
				super();
				this.elements = {
					liveRegion: this.querySelector('[id^="GalleryStatus"]'),
					viewer: this.querySelector('[id^="GalleryViewer"]'),
					thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
				};
				this.mql = window.matchMedia('(min-width: 750px)');
				if (!this.elements.thumbnails) return;

				this.elements.viewer.addEventListener(
					'slideChanged',
					debounce(this.onSlideChanged.bind(this), 500),
				);
				this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
					mediaToSwitch
						.querySelector('button')
						.addEventListener(
							'click',
							this.setActiveMedia.bind(this, mediaToSwitch.dataset.target),
						);
				});
				if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches)
					this.removeListSemantic();

				// Intercepter les clics sur les boutons de navigation du slider principal
				this.initNavigationButtons();
			}

			initNavigationButtons() {
				const prevButton = this.elements.viewer.querySelector('button[name="previous"]');
				const nextButton = this.elements.viewer.querySelector('button[name="next"]');

				if (prevButton && nextButton) {
					// Intercepter les clics avant que SliderComponent ne les traite
					prevButton.addEventListener(
						'click',
						(e) => {
							e.preventDefault();
							e.stopPropagation();
							this.navigateToPrevious();
						},
						true,
					);

					nextButton.addEventListener(
						'click',
						(e) => {
							e.preventDefault();
							e.stopPropagation();
							this.navigateToNext();
						},
						true,
					);

					// Mettre a jour les boutons au chargement
					this.updateNavigationButtons();
				}
			}

			getVisibleSlides() {
				// Retourner uniquement les slides non masques (du variant actuel)
				// On cible specifiquement les li.product__media-item du slider principal
				const slider = this.elements.viewer.querySelector('[id^="Slider-Gallery-"]');
				if (!slider) return [];

				return Array.from(slider.querySelectorAll('li.product__media-item[data-media-id]')).filter(
					(slide) =>
						!slide.classList.contains('disabled-slide') &&
						!slide.classList.contains('mobile-disabled-slide'),
				);
			}

			getCurrentSlideIndex() {
				const visibleSlides = this.getVisibleSlides();
				const activeSlide = this.elements.viewer.querySelector('[data-media-id].is-active');
				return visibleSlides.indexOf(activeSlide);
			}

			navigateToPrevious() {
				const visibleSlides = this.getVisibleSlides();
				const currentIndex = this.getCurrentSlideIndex();

				// Navigation infinie : si on est au d�but, retourner � la fin
				let prevIndex;
				if (currentIndex <= 0) {
					prevIndex = visibleSlides.length - 1;
				} else {
					prevIndex = currentIndex - 1;
				}

				if (prevIndex >= 0 && prevIndex < visibleSlides.length) {
					const prevSlide = visibleSlides[prevIndex];
					this.setActiveMedia(prevSlide.dataset.mediaId);
				}
			}

			navigateToNext() {
				const visibleSlides = this.getVisibleSlides();
				const currentIndex = this.getCurrentSlideIndex();

				// Navigation infinie : si on est � la fin, retourner au d�but
				let nextIndex;
				if (currentIndex >= visibleSlides.length - 1) {
					nextIndex = 0;
				} else {
					nextIndex = currentIndex + 1;
				}

				if (nextIndex >= 0 && nextIndex < visibleSlides.length) {
					const nextSlide = visibleSlides[nextIndex];
					const mediaId = nextSlide.dataset.mediaId;
					this.setActiveMedia(mediaId);
				}
			}

			updateNavigationButtons() {
				const prevButton = this.elements.viewer.querySelector('button[name="previous"]');
				const nextButton = this.elements.viewer.querySelector('button[name="next"]');

				if (!prevButton || !nextButton) return;

				// Pour une navigation infinie, les boutons sont toujours actifs
				prevButton.removeAttribute('disabled');
				nextButton.removeAttribute('disabled');
			}

			updateSlideCounter() {
				const counterCurrent = this.elements.viewer.querySelector('.slider-counter--current');
				const counterTotal = this.elements.viewer.querySelector('.slider-counter--total');

				if (counterCurrent && counterTotal) {
					const visibleSlides = this.getVisibleSlides();
					const currentIndex = this.getCurrentSlideIndex();

					if (currentIndex >= 0) {
						counterCurrent.textContent = currentIndex + 1;
						counterTotal.textContent = visibleSlides.length;
					}
				}
			}

			onSlideChanged(event) {
				const currentElement = event.detail.currentElement;
				const thumbnail = this.elements.thumbnails.querySelector(
					`[data-target="${currentElement.dataset.mediaId}"]`,
				);
				this.setActiveThumbnail(thumbnail);

				// Swipe : la slide visée doit devenir active pour que sa deferred-media
				// (cachée en display:none sinon) s'affiche. On le fait sans scrollTo
				// (contrairement à setActiveMedia) pour ne pas perturber le swipe.
				// L'IntersectionObserver de la vidéo cover-loop prend alors le relais
				// pour lancer/mettre en pause la lecture selon la visibilité.
				const slider = this.elements.viewer.querySelector('[id^="Slider-Gallery-"]');
				if (slider) {
					slider
						.querySelectorAll('[data-media-id].is-active')
						.forEach((el) => el.classList.remove('is-active'));
					currentElement.classList.add('is-active');
				}
			}

			setActiveMedia(mediaId) {
				const slider = this.elements.viewer.querySelector('[id^="Slider-Gallery-"]');
				if (!slider) return;

				const activeMedia =
					slider.querySelector(`[data-media-id="${mediaId}"]`) ||
					slider.querySelector('[data-media-id]');
				if (!activeMedia) {
					return;
				}

				slider.querySelectorAll('[data-media-id]').forEach((element) => {
					element.classList.remove('is-active');
				});
				activeMedia.classList.add('is-active');

				this.preventStickyHeader();
				window.setTimeout(() => {
					if (!this.mql.matches || this.elements.thumbnails) {
						activeMedia.parentElement.scrollTo({
							left: activeMedia.offsetLeft,
							behavior: 'smooth',
						});
					}
					const activeMediaRect = activeMedia.getBoundingClientRect();
					// Don't scroll if the image is already in view
					if (activeMediaRect.top > -0.5) return;
					const top = activeMediaRect.top + window.scrollY;
					window.scrollTo({ top: top, behavior: 'smooth' });
				});
				this.playActiveMedia(activeMedia);

				if (!this.elements.thumbnails) return;

				const activeThumbnail = this.elements.thumbnails.querySelector(
					`[data-target="${mediaId}"]`,
				);
				this.setActiveThumbnail(activeThumbnail);
				if (activeThumbnail) {
					this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
				}

				// Mettre a jour le compteur et les boutons
				this.updateSlideCounter();
				this.updateNavigationButtons();
			}

			setActiveThumbnail(thumbnail) {
				if (!this.elements.thumbnails || !thumbnail) return;

				this.elements.thumbnails
					.querySelectorAll('button')
					.forEach((element) => element.removeAttribute('aria-current'));
				thumbnail.querySelector('button').setAttribute('aria-current', true);
				if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

				this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
			}

			announceLiveRegion(activeItem, position) {
				const image = activeItem.querySelector('.product__modal-opener--image img');
				if (!image) return;
				image.onload = () => {
					this.elements.liveRegion.setAttribute('aria-hidden', false);
					this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
						'[index]',
						position,
					);
					setTimeout(() => {
						this.elements.liveRegion.setAttribute('aria-hidden', true);
					}, 2000);
				};
				image.src = image.src;
			}

			playActiveMedia(activeItem) {
				window.pauseAllMedia();
				const deferredMedia = activeItem.querySelector('.deferred-media');
				if (deferredMedia) deferredMedia.loadContent(false);
			}

			preventStickyHeader() {
				this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
				if (!this.stickyHeader) return;
				this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
			}

			removeListSemantic() {
				if (!this.elements.viewer.slider) return;
				this.elements.viewer.slider.setAttribute('role', 'presentation');
				this.elements.viewer.sliderItems.forEach((slide) =>
					slide.setAttribute('role', 'presentation'),
				);
			}
		},
	);
}
